import { FunctionComponent, useState } from "react";
import { useSelector } from "react-redux";
import {
  AccordionCustom,
  AccordionDetailsCustom,
  AccordionSummaryCustom,
  SummaryContainer,
  ReportRowIcons,
  ReportRow,
  ReportRowName,
  ReportSmallRowName,
  ReportRowCounter,
  Image,
  Counter,
} from "./styled.components";
import FavoriteIcon from "@mui/icons-material/Favorite";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { randomColor } from "utils";
import "../../assets/css/reportcard/index.css";

type ReportRowsProps = {
  dataRows: any;
  isSelected: boolean;
  handleOnClick: (e: any) => void;
  handleFavoriteOnClick: (e: any) => void;
  handleLinkOnClick: (e: any) => void;
};

const ReportRows: FunctionComponent<ReportRowsProps> = ({
  dataRows,
  isSelected,
  handleOnClick,
  handleFavoriteOnClick,
  handleLinkOnClick,
}) => {
  const { catalogs } = useSelector((state: any) => state.theme);
  const { context } = useSelector((state: any) => state.theme);

  const [expanded, setExpanded] = useState("panel1");

  const handleChange =
    (panel: string) => (event: any, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : "false");
    };

  const handleRenderSmallRows = (item: any, index: number) => {
    return (
      <ReportRow
        background={context?.backgroundItem}
        textColor={context?.textColor}
      >
        <ReportSmallRowName
          onClick={() => handleOnClick({ ...item, isSelected: true })}
        >
          {item.descripcionMenu}
        </ReportSmallRowName>
        <ReportRowIcons>
          <>
            {item.reciente ? (
              <WatchLaterIcon
                className={"report-icons"}
                style={{ color: catalogs?.context }}
              />
            ) : (
              <></>
            )}
            <FavoriteIcon
              className={"report-icons"}
              style={{
                color: item.favorito ? catalogs?.context : catalogs?.item,
              }}
              onClick={() => handleFavoriteOnClick(item)}
            />
          </>
          <Image
            src={"/commons/link-plus.svg"}
            onClick={() => handleLinkOnClick(item)}
          />
        </ReportRowIcons>
      </ReportRow>
    );
  };

  const handleRenderRowViews = (item: any, index: number) => {
    const color = catalogs?.context;
    const colorLateralBar = catalogs?.colorLateralBar;

    return (
      <AccordionCustom
        color={colorLateralBar || color}
        background={catalogs?.item}
        textColor={context?.textColor}
        expanded={expanded === `panel_${item.idVista}`}
        onChange={handleChange(`panel_${item.idVista}`)}
      >
        <AccordionSummaryCustom
          background={catalogs?.item}
          expandIcon={
            <ExpandMoreIcon
              style={{ fontSize: "2rem", color: color || "#e5e7eb" }}
            />
          }
          aria-controls={`panel_${item.idVista} d - content`}
          id={`panel_${item.idVista} d - header`}
        >
          <SummaryContainer>
            <ReportRowName>
              <FiberManualRecordIcon
                className={"report-icons"}
                style={{ color: color, fontSize: "2rem", paddingRight: "3px" }}
              />
              {item.descripcionMenu}
            </ReportRowName>
            <ReportRowCounter>
              <Counter
                background={context?.badgeColor}
                textColor={context?.textHoverColor}
              >
                {item.hijos.length}
              </Counter>
            </ReportRowCounter>
            <span className={"hide-sm"}>Elementos</span>
          </SummaryContainer>
        </AccordionSummaryCustom>
        <AccordionDetailsCustom background={catalogs?.item}>
          {item.hijos.map(handleRenderSmallRows)}
        </AccordionDetailsCustom>
      </AccordionCustom>
    );
  };

  return (
    <>
      {!isSelected ? (
        dataRows
          .filter((report: any) => report.idVista > 0)
          .map(handleRenderRowViews)
      ) : (
        <AccordionDetailsCustom>
          {dataRows.map(handleRenderSmallRows)}
        </AccordionDetailsCustom>
      )}
    </>
  );
};

export default ReportRows;
